<script>
  export let active = false;
</script>

<div class="carousel-item align-self-center {active ? 'active' : ''}">
  <div class="row d-flex align-items-center">
    <div class="col-12">
      <slot />
    </div>
  </div>
</div>
